import { combineReducers } from "redux";
import isAuthenticating from "./isAuthenticating";
import user from "./user";

export default combineReducers({ isAuthenticating, user });



// WEBPACK FOOTER //
// ./src/reducers/login/index.js